module.exports = __webpack_public_path__ + "img/LGO Markets.cc5ce156.png";